import {connect} from 'react-redux';
import FilePreviewHandler from './FilePreviewHandler';
import {getFile} from '../../actions/files/getFile';

export default connect(
  null,
  {getFile}
)(FilePreviewHandler);
